export const TITLE = 'Platform maintenance in progress!';
export const DESCRIPTION = 'Please note we are currently undergoing scheduled maintenance updates. Access to the app will resume shortly.';
